var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDwpMobileLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.202,
    height: 56.607,
    viewBox: "0 0 73.202 56.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 122",
    d: "m368.029 352.867-.007-.017-.007.017z",
    transform: "translate(-322.2 -330.671)",
    style: {
      fill: "#e9e7e1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 123",
    d: "m358.633 352.867-.007-.017-.007.017z",
    transform: "translate(-331.308 -330.671)",
    style: {
      fill: "#e9e7e1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 124",
    d: "m377.079 342.047-9.061 21.72 8.908 21.352a.374.374 0 0 0 .689 0l17.726-42.5a.746.746 0 0 0-.687-1.034h-16.888a.745.745 0 0 0-.687.462z",
    transform: "translate(-322.197 -341.588)",
    style: {
      fill: "#e9e7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 125",
    d: "M362.383 341.588H345.5a.746.746 0 0 0-.687 1.034l17.726 42.5a.372.372 0 0 0 .687 0l8.839-21.33-8.99-21.736a.749.749 0 0 0-.692-.468z",
    transform: "translate(-344.751 -341.588)",
    style: {
      fill: "#e9e7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 126",
    d: "m367.526 342.121-8.9 21.37 8.9 21.334a.374.374 0 0 0 .689 0l8.9-21.334-8.9-21.37a.374.374 0 0 0-.689 0z",
    transform: "translate(-331.302 -341.294)",
    style: {
      fill: "#e9e7e1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 127",
    d: "m400.5 367.018-5.027-.328-5.232.053-5.093.409-4.844-.375-5.448-.186-5.2.412-4.817.107-5.241-.543-5.289.443-4.971-.1-.143 6.806 5.327.111 5.009-.419 5.031.521 5.342-.118 5.1-.4 4.842.162 5.311.411 5.266-.432 4.854-.049 5.182.338 4.42-.246v-6.819z",
    transform: "translate(-340.44 -317.374)",
    style: {
      fill: "#e9e7e1"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwpMobileLogoLight);
export default __webpack_public_path__ + "static/media/DWP_mobile_logo_light.6c2bfddf920fe2817621aead859b26d7.svg";
export { ForwardRef as ReactComponent };